module.exports = __webpack_public_path__ + "static/media/djsb.82782047.png";